// Mock data para la landing page de Fabio Marino
// Este archivo contiene todos los datos editables de la página

export const siteConfig = {
  name: "Fabio Marino",
  whatsapp: "+34 675 210 872",
  whatsappLink: "https://wa.me/34675210872",
  email: "fabiomarino@outlook.es",
  phone: "+34 675 210 872",
  zone: "Pineda de Mar y alrededores (Barcelona)"
};

export const heroData = {
  title: "Cuidado de perros con cariño y tranquilidad",
  subtitle: "Guardería, alojamiento y paseos diarios en Pineda de Mar y alrededores, para que tu perro esté bien y tú estés tranquilo.",
  ctaPrimary: "Hablar por WhatsApp",
  ctaSecondary: "Comprobar disponibilidad"
};

export const services = [
  {
    id: 1,
    title: "Guardería de día",
    description: "Incluye cuidado continuo, paseos, descanso y supervisión durante todo el día.",
    icon: "Sun",
    image: "https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/8jgp3q0v_IMG_7422.jpeg"
  },
  {
    id: 2,
    title: "Guardería de noche",
    description: "Rutina tranquila, paseo previo al descanso y cuidado nocturno con total supervisión.",
    icon: "Moon",
    image: "https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/upr0fr9o_IMG_7420.jpeg"
  },
  {
    id: 3,
    title: "Alojamiento 24h",
    description: "Cuidado completo durante tu ausencia, paseos diarios y seguimiento con fotos y actualizaciones.",
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/pvtqtogb_IMG_7416.jpeg"
  },
  {
    id: 4,
    title: "Paseos diarios",
    description: "Paseos de 30 o 60 minutos adaptados a la energía y necesidades de tu perro.",
    icon: "Footprints",
    image: "https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/g9gewkwz_IMG_7414.jpeg"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Me cuentas sobre tu perro",
    description: "Háblame de su carácter, rutinas y necesidades especiales."
  },
  {
    step: 2,
    title: "Confirmamos fechas y detalles",
    description: "Acordamos fechas, zona y cualquier necesidad específica."
  },
  {
    step: 3,
    title: "Empiezo el cuidado",
    description: "Cuido de tu perro y te envío actualizaciones con fotos y vídeos."
  }
];

export const aboutFabio = {
  name: "Fabio Marino",
  image: "https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/zlzfi9rp_IMG_7401.jpeg",
  description: "Soy Fabio, amante de los perros desde siempre. Mi compromiso es ofrecer a cada perro un trato responsable y cercano, con un enfoque centrado en su bienestar, rutina y calma. Trabajo en Pineda de Mar y alrededores, donde cada perro recibe la atención personalizada que merece.",
  highlights: [
    "Trato responsable y cercano",
    "Enfoque en bienestar, rutina y calma",
    "Servicio personalizado en Pineda de Mar y alrededores"
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "María García",
    pet: "Luna, Golden Retriever",
    text: "Fabio cuidó de Luna durante nuestras vacaciones y fue increíble. Recibíamos fotos cada día y Luna volvió feliz. ¡Repetiremos seguro!",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    pet: "Max, Bulldog Francés",
    text: "La flexibilidad horaria de Fabio es genial. Necesitábamos guardería de día de última hora y nos ayudó sin problema. Max lo adora.",
    rating: 5
  },
  {
    id: 3,
    name: "Laura Gómez",
    pet: "Thor, Labrador",
    text: "Dejamos a Thor todo el fin de semana y fue como estar en casa. Fabio nos enviaba fotos y vídeos cada día y lo vimos feliz y tranquilo. Repetiremos sin duda.",
    rating: 5
  },
  {
    id: 4,
    name: "David López",
    pet: "Rocky, Labrador",
    text: "Los paseos diarios han cambiado el comportamiento de Rocky. Ahora está más tranquilo y feliz. Fabio sabe tratar a los perros.",
    rating: 5
  }
];

export const pricing = [
  { service: "Paseos diarios (30 min)", price: "Desde 8€" },
  { service: "Paseos diarios (60 min)", price: "Desde 12€" },
  { service: "Guardería de día", price: "Desde 20€" },
  { service: "Guardería de noche", price: "Desde 25€" },
  { service: "Alojamiento 24h", price: "Desde 30€" }
];

export const serviceZones = [
  "Pineda de Mar",
  "Calella",
  "Santa Susanna",
  "Malgrat de Mar",
  "Palafolls",
  "Blanes",
  "Tordera"
];

export const faqs = [
  {
    question: "¿Qué tengo que llevar para mi perro?",
    answer: "Su comida habitual, correa y cualquier indicación especial. Si necesita medicación, indícalo al reservar."
  },
  {
    question: "¿Enviáis fotos o actualizaciones?",
    answer: "Sí, envío fotos y mensajes para que sepas cómo está tu perro durante el cuidado."
  },
  {
    question: "¿Cuidas perros no sociables?",
    answer: "Sí, cada caso se valora de forma individual para garantizar bienestar y seguridad."
  },
  {
    question: "¿Puedes administrar medicación?",
    answer: "Sí, siempre que se indiquen claramente las pautas."
  },
  {
    question: "¿Cómo funcionan las cancelaciones?",
    answer: "Las cancelaciones deben avisarse con antelación. Las condiciones se confirman al reservar."
  }
];

export const legalLinks = [
  { title: "Aviso Legal", href: "#aviso-legal" },
  { title: "Política de Privacidad", href: "#privacidad" },
  { title: "Política de Cookies", href: "#cookies" }
];

export const legalContent = {
  avisoLegal: {
    title: "Aviso Legal",
    content: `Titular: Fabio Marino
Actividad: Servicios de cuidado y alojamiento de mascotas
Ubicación: Pineda de Mar (Barcelona)
Email de contacto: fabiomarino@outlook.es
Teléfono: +34 675 210 872

Este sitio web tiene como finalidad ofrecer información sobre los servicios de cuidado de mascotas. El uso del sitio implica la aceptación de las condiciones aquí descritas.`
  },
  privacidad: {
    title: "Política de Privacidad",
    content: `Responsable: Fabio Marino
Finalidad: Gestionar solicitudes de contacto y prestación de servicios.
Legitimación: Consentimiento del usuario al enviar el formulario.
Conservación: Los datos se conservarán únicamente el tiempo necesario para atender la solicitud.
Derechos: Puedes solicitar acceso, rectificación o eliminación de tus datos escribiendo a fabiomarino@outlook.es.`
  },
  cookies: {
    title: "Política de Cookies",
    content: `Este sitio web utiliza cookies técnicas necesarias para su funcionamiento. No se utilizan cookies de terceros con fines publicitarios.`
  }
};

export const serviceOptions = [
  "Guardería de día",
  "Guardería de noche",
  "Alojamiento 24h",
  "Paseos diarios"
];

export const dogSizes = [
  "Pequeño (hasta 10kg)",
  "Mediano (10-25kg)",
  "Grande (más de 25kg)"
];

export const dogCharacters = [
  "Tranquilo",
  "Activo",
  "Sociable",
  "Tímido",
  "Juguetón"
];

// Chatbot configuration
export const chatbotConfig = {
  name: "Asistente de Fabio",
  welcomeMessage: "¡Hola! Soy el asistente de Fabio 🐶 ¿Qué necesitas: guardería de día, guardería de noche, alojamiento o paseos diarios?",
  quickButtons: [
    "Guardería de día",
    "Guardería de noche",
    "Alojamiento",
    "Paseos diarios"
  ],
  systemPrompt: `Eres el asistente virtual de Fabio Marino, un cuidador profesional de perros en Pineda de Mar y alrededores (Barcelona).

SERVICIOS DISPONIBLES (únicos):
- Guardería de día
- Guardería de noche
- Alojamiento
- Paseos diarios

NO ofrezcas ni menciones "visitas a domicilio" ni "visitas" bajo ningún concepto.

Tu trabajo es cualificar al cliente con estas preguntas (máximo 4-5, tono natural y cercano):
1. ¿En qué zona estás? (Pineda de Mar / alrededores / otra)
2. ¿Qué fechas necesitas? (inicio y fin)
3. ¿Cómo es tu perro? (tamaño + edad)
4. ¿Carácter? (sociable / tímido / reactivo / cachorro)
5. ¿Necesita medicación o alguna rutina especial? (sí/no + detalles)

AJUSTES POR SERVICIO:
- Paseos diarios: preguntar duración (30/60 min) y horario preferido
- Guardería de día: preguntar horario de entrada/salida
- Guardería de noche o Alojamiento: preguntar si duerme bien con otros perros y si hay ansiedad nocturna

CIERRE:
Cuando tengas la información, ofrece: "¿Quieres que Fabio te confirme disponibilidad por WhatsApp?"

Zona de servicio: Pineda de Mar, Calella, Santa Susanna, Malgrat de Mar, Palafolls, Blanes, Tordera

Responde siempre en español de España, de forma cercana y amigable. Usa emojis ocasionalmente.`
};
